import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { deleteBoardQueueGroup } from '../requests';
import type { DeleteBoardQueueGroupRequest } from '../types';

export const useDeleteBoardQueueGroup = (
  params: DeleteBoardQueueGroupRequest,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteBoardQueueGroup(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardQueueGroups],
      });
    },
  });
};
